module.exports = __webpack_public_path__ + "static/media/Home.9aad6f83.png";